import styled from 'styled-components';

import checkingBoxPurple from 'design-system/src/assets/icons/checkingBoxPurple.svg';
import { focusVisibleStyles, standardTransitionStyles } from 'design-system/src/sharedStyles';

type FloatingEditButtonProps = {
  top: string;
  right: string;
  onClick: () => void;
};

const FloatingEditButtonContainer = styled.button<{ $top: string; $right: string }>`
  position: absolute;
  top: ${({ $top }) => $top};
  right: ${({ $right }) => $right};
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  cursor: pointer;

  // transparent border for windows high contrast mode, which removes box shadows but makes all borders 100% opaque black
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 50%;
  box-shadow: 0px 8px 20px 4px rgba(0, 0, 0, 0.3);
  width: 48px;
  height: 48px;
  background-color: var(--white);

  ${standardTransitionStyles}
  ${focusVisibleStyles}

  &:hover {
    background-color: var(--grayscale-50);
  }
`;

const EditIcon = styled.img`
  width: 20px;
  height: 20px;
`;

/**
 * An edit button that floats over the page.
 * Use top and right to position the button.
 */
export const FloatingEditButton = ({ top, right, onClick }: FloatingEditButtonProps) => {
  return (
    <FloatingEditButtonContainer $top={top} $right={right} onClick={onClick}>
      <EditIcon src={checkingBoxPurple} alt="Edit letter content" />
    </FloatingEditButtonContainer>
  );
};
